const common = {
  // brand & nav
  brand: "久久久精品",
  brandSub: "优质影视资源聚合平台",
  navHome: "首页",
  navMovie: "电影",
  navTv: "电视剧",
  navVariety: "综艺",
  navSearch: "搜索",
  navAbout: "关于我们",
  navFavorites: "收藏",
  navCategories: "分类",
  backHome: "返回首页",

  // common
  loading: "加载中...",
  empty: "暂无内容",
  resetFilter: "重置筛选",
  loadMore: "加载更多",
  noMore: "已经到底啦",
  viewAll: "查看全部",
  more: "更多",
  all: "全部",
  year: "年份",
  region: "地区",
  sort: "排序",
  sortLatest: "最新",
  sortHot: "热门",
  sortRating: "评分",
  detail: "详情",
  addFavorite: "收藏",
  favorited: "已收藏",
  share: "分享",
  shareSuccess: "链接已复制到剪贴板",
  searchPlaceholder: "搜索影片、剧集、综艺…",
  results: "条结果",
  breadcrumbHome: "首页",

  // home
  heroTag: "本月热力推荐",
  heroPlayInfo: "查看详情",
  categoryQuick: "分类频道",
  categoryQuickDesc: "按类别快速进入，发现你想看的每一部精品",
  latest: "最新上线",
  latestDesc: "紧跟更新节奏，第一时间掌握新鲜影视",
  featured: "编辑精选",
  featuredDesc: "由编辑团队精心挑选的高分佳作与专题合集",
  topicCollection: "热门专题合集",
  hotRanking: "本周热播榜",
  viewDetail: "查看详情",
  typeMovie: "电影",
  typeTv: "电视剧",
  typeVariety: "综艺",
  itemCount: "部作品",

  // category
  categoryMovieTitle: "电影精选",
  categoryTvTitle: "电视剧精选",
  categoryVarietyTitle: "综艺精选",
  categoryMovieDesc: "汇聚国内外院线大片与高分佳作，涵盖动作、科幻、剧情、悬疑等多种类型。",
  categoryTvDesc: "精选热播剧集与经典长篇，从都市情感到历史传奇，陪你追完每一集。",
  categoryVarietyDesc: "轻松解压的综艺大集合，真人秀、脱口秀、旅行美食应有尽有。",
  filterTitle: "筛选条件",
  resultCountText: "共筛选出",
  noResultTitle: "没有找到匹配的影视",
  noResultDesc: "换个筛选条件试试，或重置后重新浏览全部内容。",

  // detail
  synopsis: "剧情简介",
  detailInfo: "详细信息",
  director: "导演",
  cast: "主演",
  genre: "类型",
  duration: "片长",
  episodes: "集数",
  status: "更新状态",
  releaseYear: "上映年份",
  rating: "评分",
  relatedTitle: "相关推荐",
  relatedDesc: "根据类型为你匹配的相似作品",
  categoryEntry: "所属分类",
  copyLink: "复制链接",

  // search
  searchTitle: "搜索影视",
  searchResultFor: "搜索关键词",
  filterType: "类型筛选",
  noSearchTitle: "没有找到相关影视",
  noSearchDesc: "换个关键词试试，或看看下面为你推荐的热门内容。",
  recommendForYou: "为你推荐",

  // about
  aboutTitle: "关于 久久久精品",
  aboutLead: "久久久精品是一个专注于优质影视资源聚合的浏览平台，我们把电影、电视剧与综艺的精选内容整理成清晰易读的卡片，帮助你在海量作品中快速找到想看的那一部。",
  aboutFeature1Title: "内容丰富多元",
  aboutFeature1Desc: "覆盖电影、电视剧、综艺三大类别，类型多样、更新及时，满足不同口味的观影需求。",
  aboutFeature2Title: "筛选清晰高效",
  aboutFeature2Desc: "支持地区、年份、排序等多维筛选，配合关键词搜索，几秒钟定位心仪作品。",
  aboutFeature3Title: "介绍深入详尽",
  aboutFeature3Desc: "每部作品都配有封面、演职员、剧情简介与相关推荐，阅读层级清晰、浏览舒适。",
  aboutStatWorks: "收录作品",
  aboutStatCategory: "内容分类",
  aboutStatUsers: "月浏览用户",
  contactTitle: "联系我们",
  contactDesc: "有任何建议、合作意向或内容纠错，欢迎通过下方表单与我们取得联系。",
  formName: "你的称呼",
  formEmail: "邮箱地址",
  formSubject: "反馈主题",
  formMessage: "想说的话",
  formMessageHint: "最多 500 字",
  formSubmit: "提交反馈",
  formSending: "提交中...",
  formSuccess: "提交成功，感谢你的反馈！",
  formError: "提交失败，请稍后再试。",
  legalTitle: "法律声明与版权",
  legalText: "本站为影视内容聚合与推荐演示平台，所有影视资料、片名、演职员等信息均为虚拟示例数据，仅用于界面与功能演示，不提供任何播放、下载与在线观看服务。如有侵权请联系我们处理。",

  // footer
  footerDesc: "聚合优质影视资源，让每一次浏览都能遇见好作品。",
  footerNav: "导航",
  footerCategory: "分类",
  footerFollow: "关注我们",
  footerCopyright: "久久久精品 · 版权所有",
  footerDisclaimer: "本站为前端演示站，数据为虚拟示例",

  // 404
  notFoundTitle: "页面走丢了",
  notFoundDesc: "你访问的页面不存在，不如回首页继续探索精品影视。",

  favoritesTitle: "我的收藏",
  favoritesDesc: "收藏的影视会保存在本机浏览器中",
  favoritesEmpty: "还没有收藏任何影视，去逛逛吧",
  goExplore: "去发现",
};

export default common;